import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { TokenStorageService } from '../services/token-storage.service';
import { ApiProfileService } from '../services/api-profile.service';

export const authenticationGuard: CanActivateFn = () => {
  const tokenStorage = inject(TokenStorageService);
  const apiProfileService = inject(ApiProfileService);
  const router = inject(Router);

  return tokenStorage.hasCredentials(apiProfileService.activeProfile.id)
    ? true
    : router.createUrlTree(['/qlcv']);
};
